import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSparkle3: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconSparkle3"><Path d="M15.8174 8.18164L22 10.5596V13.4404L15.8174 15.8174L13.4404 22H10.5596L8.18164 15.8174L2 13.4404V10.5596L8.18164 8.18164L10.5596 2H13.4404L15.8174 8.18164Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSparkle3;
